module.exports = __webpack_public_path__ + "img/partner-1.7c4115b5.png";